<template>
    <div
            class="resource-table loadable"
            :class="{loading: loading}"
    >
        <div class="table-wrapper">
            <table class="table">
                <thead>
                    <tr>
                        <slot name="header">
                            <th>
                                Default
                            </th>
                        </slot>
                    </tr>
                </thead>
                <tbody>
                    <template v-if="elements !== null">
                        <template v-if="elements.length !== 0">
                            <tr
                                    v-for="element in elements"
                            >
                                <slot
                                        :element="element"
                                >
                                    <td colspan="999">
                                        Element
                                    </td>
                                </slot>
                            </tr>
                        </template>
                        <tr v-else>
                            <td colspan="999">
                                <slot name="empty">
                                    {{$t('noRecords')}}
                                </slot>
                            </td>
                        </tr>
                    </template>
                    <tr v-else>
                        <td colspan="999">
                            <template v-if="loading">
                                {{$t('loading')}}
                            </template>
                            <template v-if="error">
                                {{$t('error')}}
                            </template>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="pagination" v-if="paginationMeta.total_pages > 1">
            <button
                    type="button"
                    :disabled="paginationParams.page <= 1"
                    @click="paginationParams.page--; loadResource()"
            >
                ←
            </button>
            <button
                    type="button"
                    v-for="(page) in availablePages"
                    :key="page"
                    :class="{active: paginationParams.page === page}"
                    :disabled="paginationParams.page === page"
                    @click="paginationParams.page = page; loadResource()"
            >
                {{ page }}
            </button>
            <button
                    type="button"
                    :disabled="paginationParams.page >= paginationMeta.total_pages"
                    @click="paginationParams.page++; loadResource()"
            >
                →
            </button>
        </div>
        <div class="loader-wrapper">
            <Spinner/>
        </div>
    </div>
</template>

<script>
  import Spinner from "./Spinner";

  export default {
      components: {
          Spinner
      },
      props: {
          resource: {
              type: Object,
              required: true,
          },
          params: {
              required: false,
              default: () => ({})
          },
          defaultParams: {
              required: false,
              default: () => ({})
          },
          perPage: {
              required: false,
              default: 5
          }
      },
      data(){
          return {
              elements: null,
              loading: true,
              error: false,
              paginationParams: {
                  page: 1,
                  per_page: this.perPage,
              },
              paginationMeta: {
                  total: null,
                  total_pages: null,
                  count: null,
              }
          };
      },
      methods: {
          loadResource(){
              this.error = false;
              this.loading = true;

              this.resource.index(Object.assign({}, this.defaultParams, this.params, this.paginationParams))
                  .then((response) => {
                      this.loading = false;
                      this.elements = response.data.data;
                      this.paginationMeta = response.data.meta.pagination;

                  }).catch(() => {
                      this.loading = false;
                      this.elements = null;
                      this.error = true;
                  })
          }
      },
      computed: {
          availablePages(){
              let pages = [];

              if(!this.loading && !this.error && this.paginationMeta.total_pages){
                  for (let i = 1; i < this.paginationMeta.total_pages + 1; i++) {
                      pages.push(i);
                  }
              }

              return pages;
          }
      },
      watch:{
          'paginationParams.page': function(value){
              this.loadResource();
          }
      },
      mounted(){
          this.loadResource();
      }
  }
</script>

<style scoped lang="scss">
    @import '../styles/variables';

    .table-wrapper{
        overflow-x: auto;
        overflow-y: hidden;
    }
    
    .pagination{
        text-align: center;
    }

    button.active{
        background-color: $pallete_main_color;
        color: #ffffff;
        cursor: default;
    }
</style>